import 'styles/main.css'

import {Router, Route, browserHistory} from 'react-router'
import {Provider} from 'react-redux'

import App from 'pages/App'

/**
 * DO NOT REMOVE COMMENTED CODE
 * This is intended if the 'async import version' becomes problematic
 * Then uncomment the 'sync import version' and comment the `async version`
 */
import AccountSetting from 'pages/AccountSetting/AccountSetting'
import Login from 'pages/Login'
import Register from 'pages/Register'
import Library, * as LibraryPages from 'pages/Library'
import RegisterComplete from 'pages/RegisterComplete'
import Dashboard from 'pages/Dashboard'
import ForgotPassword from 'pages/ForgotPassword'
import SuccessForgotPassword from 'pages/SuccessForgotPassword'
import NotFound from 'pages/NotFound'
import Report from 'pages/Reports/Report'
import ReportSummary from 'pages/Reports/Sales/ReportSummary'
import GrossProfit from 'pages/Reports/Sales/GrossProfit'
import ItemSales from 'pages/Reports/Sales/ItemSales'
import PaymentMethods from 'pages/Reports/Sales/PaymentMethods'
import CategorySales from 'pages/Reports/Sales/CategorySales'
import ModifierSales from 'pages/Reports/Sales/ModifierSales'
import Discounts from 'pages/Reports/Sales/Discounts'
import Taxes from 'pages/Reports/Sales/Taxes'
import Gratuity from 'pages/Reports/Sales/Gratuity'
import CollectedBy from 'pages/Reports/Sales/CollectedBy'
import ServedBy from 'pages/Reports/Sales/ServedBy'
import ResendVerificationEmail from 'pages/ResendVerificationEmail/ResendVerificationEmail'
import Shift from 'pages/Reports/Shift'
import Invoices from 'pages/Reports/Invoices'
import ResetPassword from 'pages/ResetPassword/ResetPassword'
import SuccessResetPassword from 'pages/SuccessResetPassword/SuccessResetPassword'
import Transaction from 'pages/Reports/Transaction'
import Account from 'pages/AccountSetting/Account'
import PublicProfile from 'pages/AccountSetting/PublicProfile'
import Version from 'pages/Version'
import Checkout from 'pages/AccountSetting/Checkout'
import Receipt from 'pages/AccountSetting/Receipt'
import EmailNotification from 'pages/AccountSetting/EmailNotification'
import Billing from 'pages/AccountSetting/Billing/Billing'
import Customer, {CustomerList, Feedback, Loyalty} from 'pages/Customers'
import Employee, {Permission, List as EmployeeList} from 'pages/Employees'
import Inventory, {Summary, Transfer, Adjustment, PurchaseOrder, Supplier} from 'pages/Inventory'
import Ingredient, {Library as IngredientLibrary, Category as IngredientCategory, Recipes as IngredientRecipes} from 'pages/Ingredient'
import Outlet, {List as OutletList} from 'pages/Outlets'
import {isSubscriptionExpired, showSubscriptionExpiredModal, hideSubscriptionExpiredModal} from 'actions/subscriptionExpired'
import {clearError, setAuthFromLocal, setProfile, setAuthState, setAuthFromApi} from 'actions'
import {reset, error as actNotifError} from 'actions/notifications'
import {syncHistoryWithStore} from 'react-router-redux'
import FeedbackReplyForm from 'pages/FeedbackReplyForm'
import VerifyEmail from 'pages/VerifyEmail'
import ConfirmEmployee from 'pages/ConfirmEmployee'
import SuccessConfirmEmployee from 'pages/ConfirmEmployee/SuccessConfirmEmployee'
import FeedbackForm from 'pages/FeedbackForm'
import BillingRedirect from 'pages/BillingRedirect'
import VerifyEmailAlertRecipient from 'pages/VerifyEmailAlertRecipient'
import moment from 'moment'
import * as apiProfile from 'api/profile'
import * as _ from 'lodash'
const storeJS = require('store')

module.exports = (store) => {
  // This array consists of routes that CANNOT be accessed by manager
  const ManagerRouteExcept = [
    '/library/tax',
    '/library/gratuity',
    '/inventory/suppliers',
    '/employees/permission',
    '/outlets',
    '/outlets/list',
    '/settings',
    '/settings/billing',
    '/settings/public_profile',
    '/settings/checkout',
    '/settings/email'
  ]

  // This array consists of routes that CAN be accessed by staff
  const StaffRouteOnly = [
    '/settings/accounts'
  ]

  const routes = () => {
    const history = syncHistoryWithStore(browserHistory, store)
    return (
      <Provider store={store}>
        <Router history={history}>
          <Route path='/version' component={Version} />
          <Route onEnter={fillApplicationState} component={App} onChange={handleOnChange}>
            <Route path='/feedback/reply-form/:token' hideHeader component={FeedbackReplyForm} />
            <Route path='/feedback/feedback-form/:token/:quality' hideHeader component={FeedbackForm} />
            <Route path='/confirm-employee-invitation' component={ConfirmEmployee} />
            <Route path='/success-confirm-employee-invitation' component={SuccessConfirmEmployee} />
            <Route path='/verify-email-alert-recipient/:token' component={VerifyEmailAlertRecipient} />
            <Route path='/' onEnter={handleStaffAccess} />
            <Route onEnter={shouldLogin}>
              <Route path='/' component={Dashboard} onEnter={handleStaffAccess} />
              <Route path='/dashboard' component={Dashboard} onEnter={handleAccess} />
              <Route path='/reports' component={Report}>
                <Route path='/reports/summary' component={ReportSummary} onEnter={handleAccess} />
                <Route path='/reports/gross_profit' component={GrossProfit} onEnter={handleAccess} />
                <Route path='/reports/item_sales' component={ItemSales} onEnter={handleAccess} />
                <Route path='/reports/payment_methods' component={PaymentMethods} onEnter={handleAccess} />
                <Route path='/reports/category_sales' component={CategorySales} onEnter={handleAccess} />
                <Route path='/reports/modifier_sales' component={ModifierSales} onEnter={handleAccess} />
                <Route path='/reports/discounts' component={Discounts} onEnter={handleAccess} />
                <Route path='/reports/taxes' component={Taxes} onEnter={handleAccess} />
                <Route path='/reports/gratuity' component={Gratuity} onEnter={handleAccess} />
                <Route path='/reports/staff' component={CollectedBy} onEnter={handleAccess} />
                <Route path='/reports/server' component={ServedBy} onEnter={handleAccess} />
                <Route path='/reports/shifts' component={Shift} onEnter={handleAccess} />
                <Route path='/reports/invoices' component={Invoices} onEnter={handleAccess} />
                <Route path='/reports/transactions' component={Transaction} onEnter={handleAccess} />
                <Route path='/reports/transactions' component={Transaction} onEnter={handleAccess} />
                <Route path='/reports/invoices' component={Invoices} onEnter={handleAccess} />
              </Route>
              <Route path='/library' component={Library}>
                <Route path='/library/list' component={LibraryPages.Item} onEnter={handleAccess} />
                <Route path='/library/category' component={LibraryPages.Category} onEnter={handleAccess} />
                <Route path='/library/discount' component={LibraryPages.Discount} onEnter={handleAccess} />
                <Route path='/library/gratuity' component={LibraryPages.Gratuity} onEnter={handleAccess} />
                <Route path='/library/modifier' component={LibraryPages.Modifier} onEnter={handleAccess} />
                <Route path='/library/tax' component={LibraryPages.Tax} onEnter={handleAccess} />
              </Route>
              <Route path='/settings' component={AccountSetting} >
                <Route path='/settings/accounts' component={Account} onEnter={handleAccess} />
                <Route path='/settings/billing' component={Billing} onEnter={handleAccess} />
                <Route path='/settings/checkout' component={Checkout} onEnter={handleAccess} />
                <Route path='/settings/public_profile' component={PublicProfile} onEnter={handleAccess} />
                <Route path='/settings/receipt' component={Receipt} onEnter={handleAccess} />
                <Route path='/settings/email' component={EmailNotification} onEnter={handleAccess} />
              </Route>
              <Route path='customers' component={Customer}>
                <Route path='/customers/list' component={CustomerList} onEnter={handleAccess} />
                <Route path='/customers/feedback_list' component={Feedback} onEnter={handleAccess} />
                <Route path='/customers/loyalty' component={Loyalty} onEnter={handleAccess} />
              </Route>
              <Route path='/employees' component={Employee}>
                <Route path='/employees/list' component={EmployeeList} onEnter={handleAccess} />
                <Route path='/employees/permission' component={Permission} onEnter={handleAccess} />
              </Route>
              <Route path='/inventory' component={Inventory}>
                <Route path='summary' component={Summary} onEnter={handleAccess} />
                <Route path='suppliers' component={Supplier} onEnter={handleAccess} />
                <Route path='purchase_orders' component={PurchaseOrder} onEnter={handleAccess} />
                <Route path='transfer' component={Transfer} onEnter={handleAccess} />
                <Route path='adjustment' component={Adjustment} onEnter={handleAccess} />
              </Route>
              <Route path='/ingredient' component={Ingredient}>
                <Route path='list' component={IngredientLibrary} onEnter={handleAccess} />
                <Route path='categories' component={IngredientCategory} onEnter={handleAccess} />
                <Route path='recipes' component={IngredientRecipes} onEnter={handleAccess} />
              </Route>
              <Route path='/outlets' component={Outlet}>
                <Route path='/outlets/list' component={OutletList} onEnter={handleAccess} />
              </Route>
              <Route path='/billings/redirect' component={BillingRedirect} onEnter={handleAccess} />
            </Route>
            <Route onEnter={shouldNotLogin}>
              <Route path='/login' component={Login} />
              <Route path='/register(/:chapcha)' component={Register} />
              <Route path='/register-complete' component={RegisterComplete} />
              <Route path='/forgot' component={ForgotPassword} />
              <Route path='/reset-password/:token' component={ResetPassword} />
              <Route path='/success-reset-password' component={SuccessResetPassword} />
              <Route path='/success-forgot-password' component={SuccessForgotPassword} />
              <Route path='/resend' component={ResendVerificationEmail} />
              <Route path='/verify-email/:token' component={VerifyEmail} />
              <Route path='/confirm-employee-invitation' component={ConfirmEmployee} />
              <Route path='/success-confirm-employee-invitation' component={SuccessConfirmEmployee} />
            </Route>
          </Route>
          <Route path='*' component={NotFound} />
        </Router>
      </Provider>
    )
  }
  function handleOnChange (prevState, nextState) {
    // reset the notification.
    store.dispatch(reset())
  }

  function fillApplicationState (nextState, replace, callback) {
    const {moka: {loggedIn}} = store.getState()
    store.dispatch(clearError())

    if (isLocalStorageNameSupported()) {
      store.dispatch(setAuthFromLocal())
      setTimeout(function () { callback() }, 100)
    } else {
      if (loggedIn) {
        apiProfile.getProfile().then((response) => {
          store.dispatch(setAuthFromApi(response.data))
          setTimeout(function () { callback() }, 100)
        })
      } else {
        callback()
      }
    }
  }

  function handleAccess (...args) {
    const [routes, replace] = args
    const {moka} = store.getState()
    const {user, loggedIn} = moka
    if (loggedIn) {
      if (user.is_manager && _.includes(ManagerRouteExcept, routes.location.pathname)) {
        replace('/dashboard')
      } else if (!user.is_manager && !user.is_owner && !_.includes(StaffRouteOnly, routes.location.pathname)) {
        replace('/settings/accounts')
      }
    }
  }

  function shouldNotLogin (nextState, replace) {
    const {moka} = store.getState()
    const {loggedIn} = moka

    if (loggedIn) {
      replace('/')
    }
  }

  function shouldLogin (nextState, replace) {
    const {moka} = store.getState()
    const {loggedIn} = moka

    if (!loggedIn) {
      replace('/login?next=' + nextState.location.pathname)
      store.dispatch(actNotifError('You must be Signed in'))
    }
  }

  function handleStaffAccess (nextState, replace) {
    const {moka} = store.getState()
    const {user, loggedIn} = moka
    if (loggedIn) {
      if (!user.is_manager && !user.is_owner) {
        replace('/settings/accounts')
      } else {
        replace('/dashboard')
      }
    } else {
      replace('/login')
    }
  }

  axios.interceptors.request.use(function (config) {
    // ONLY SEND AUTHORIZATION IF ITS GOING TO MOKAPOS.COM
    // THIS LOGIC IS FOR SOLVING AUTHORIZATION PROBLEM HITTING S3 ENDPOINT
    if (config.url.includes('mokapos.com')) {
      let rememberToken = Cookies.get('remember_token')
      config.headers['Authorization'] = rememberToken
    }
    return config
  }, function (error) {
    // Do something with request error
    return Promise.reject(error)
  })

  axios.interceptors.response.use(function (response) {
    if (response.config.url.match(/profile/g)) {
      store.dispatch(setAuthState(true, response.data))
      store.dispatch(setProfile(response.data))
      if (moment(response.data.business.expired_at) <= moment()) {
        store.dispatch(isSubscriptionExpired(true))
        store.dispatch(showSubscriptionExpiredModal())
        if (window.location.pathname !== '/settings/billing') {
          forwardTo('/settings/billing')
        }
      } else {
        store.dispatch(isSubscriptionExpired(false))
        store.dispatch(hideSubscriptionExpiredModal())
      }
    }
    return response
  }, function (error) {
    if (error.response.status === 401) {
      if (error.response.data.error) {
        store.dispatch(actNotifError(error.response.data.error))
        return Promise.reject(error)
      } else {
        resetLoggedIn()
        return Promise.reject(new Error('You must be Signed in'))
      }
    } else {
      return Promise.reject(error)
    }
  })

  axios.interceptors.request.use(function (config) {
    let rememberToken = Cookies.get('remember_token')
    // only include auth header if it is new endpoint
    const serviceHost = process.env.MOKA_SERVICE_HOST
    if (config.url.startsWith(serviceHost)) {
      config.headers['Authorization'] = rememberToken
    }
    return config
  }, function (error) {
    // Do something with request error
    return Promise.reject(error)
  })

  function resetLoggedIn () {
    Cookies.remove('remember_token', { path: '/', domain: '.mokapos.com' })
    storeJS.clearAll()
    window.location.reload()
  }

  function forwardTo (location) {
    browserHistory.push(location)
  }

  function isLocalStorageNameSupported () {
    let testKey = 'test'
    let storage = window.localStorage
    try {
      storage.setItem(testKey, '1')
      storage.removeItem(testKey)
      return true
    } catch (error) {
      return false
    }
  }

  return routes
}



// WEBPACK FOOTER //
// ./app/routes.js